<template>
  <div class="d-flex flex-column">
    <div class="grid-header">
      <h1>{{ $t("rappels_mensuales_factura.titulo") }}</h1>
      <div class="toolbar">
      </div>
    </div>

    <DxDataGrid v-bind="gridProperties" :data-source="gridSource" ref="grid" class="dx-card wide-card grid-rappels-mensuales">
      <DxToolbar>
        <DxItem location="after" template="exportButtonTemplate" />
      </DxToolbar>
      <DxColumn data-field="Anyo" :caption="$t('rappels_mensuales.grid.anyo')" data-type="number"></DxColumn>
      <DxColumn data-field="Mes" :caption="$t('rappels_mensuales.grid.mes')" cell-template="mesTemplate">
        <DxLookup v-bind="getLookup('rappels_mensuales', 'mes')"></DxLookup>
      </DxColumn>
      <DxColumn data-field="EmpresaServicios" :caption="$t('rappels_mensuales.grid.empresa_servicios')"></DxColumn>
      <DxColumn data-field="TipoElemento" :caption="$t('rappels_mensuales.grid.tipo_elemento')">
        <DxLookup column-auto-width="true" v-bind="getLookup('rappels_mensuales', 'tipo_elemento')"></DxLookup>
      </DxColumn>
      <DxColumn data-field="TipoSuministro" :caption="$t('rappels_mensuales.grid.tipo_suministro')">
        <DxLookup column-auto-width="true" v-bind="getLookup('rappels_mensuales', 'tipo_suministro')"></DxLookup>
      </DxColumn>
      <DxColumn data-field="ComisionTotal" :caption="$t('rappels_mensuales.grid.comision_total')" />
      <DxColumn data-field="NumOperaciones" :caption="$t('rappels_mensuales.grid.num_operaciones')" data-type="number"></DxColumn>
      <DxColumn data-field="ComisionPorOperacion" :caption="$t('rappels_mensuales.grid.comision_por_operacion')" />
      <DxColumn data-field="PotenciaMax" :caption="$t('rappels_mensuales.grid.potencia_max')" data-type="number"
        cell-template="potenciaTemplate">
      </DxColumn>
      <DxColumn type="buttons" :caption="$t('rappels_mensuales.grid.acciones')" :fixed="true" fixed-position="right" width="100px"  :buttons="[
        {
          cssClass: 'btn btn-link text-decoration-none btn-sm',
          icon: 'fa-solid fa-magnifying-glass text-success',
          hint: $t('rappels_mensuales.grid.ver_detalle'),
          onClick: (e: any) => verDetalle(e)
        }
      ]"/>
      <DxColumnFixing :enabled="true" />

      <template #mesTemplate="{ data }">
        <p class="text-center mb-0">
          {{ $t(`rappels_mensuales.mes.${data.value}`) }}
        </p>
      </template>
      <template #potenciaTemplate="{ data }">
        <span v-if="data.value">{{ data.value }} kW</span>
      </template>
      <template #exportButtonTemplate>
        <button type="button" @click="onExporting" class="btn btn-sm btn-light d-flex align-items-center gap-2 m-2">
          <i class="fas fa-file-excel exportar-excel"></i>
          <span class="text-primary">{{ $t("shared.ui.buttons.exportToExcel") }}</span>
        </button>
      </template>
    </DxDataGrid>
  </div>
</template>

<script setup lang="ts">
import { useApi } from "@api/integration";
import {
  DxColumn,
  DxDataGrid,
  DxLookup,
  DxColumnFixing,
  DxItem,
  DxToolbar,
  type DxDataGridTypes,
} from "devextreme-vue/data-grid";
import {
  getDefaultGridProperties,
  getLookup,
  exportGridToExcel,
} from "@helpers/grid-helper";
import { useModalService } from "@services/modal-service";
import type CustomStore from "devextreme/data/custom_store";
import { onMounted, ref } from "vue";
import type DevExpress from "devextreme";
import { useIntl } from "@/.shared/services/i18n/i18nservice";
import RappelMensualDetail from "@/components/liquidaciones/RappelMensualDetail.vue";
import { type DXLoadOptions } from "@/.shared/.api";

const props = defineProps<{
  templateData: DxDataGridTypes.MasterDetailTemplateData;
}>();

const api = useApi();
const gridSource = ref<CustomStore>();
const grid = ref<DxDataGrid>();
const modal = useModalService();
const intl = useIntl();

const gridProperties: Partial<DxDataGrid> = {
  ...getDefaultGridProperties(),
  remoteOperations: false,
  paging: {
    pageSize: 4,
  },
  pager: {
    showPageSizeSelector: false,
  }
}

onMounted(async () => {
  gridSource.value = api.apiStore({
    key: "Id",
    load: async(p) => {

      const q = p as DXLoadOptions;

      if (q.filter != null && q.filter.length >= 0)
        q.filter = [["IdFactura", "=", props.templateData.key], "and", q.filter];
      else
        q.filter = ["IdFactura", "=", props.templateData.key];
      return await api.callStandardApi("getRappelsMensualesEnergiaFacturaForGrid", { showLoading: false }, q)
    }

  });

});

async function verDetalle(data: DevExpress.ui.dxDataGrid.ColumnButtonClickEvent) {
  let title = `${intl.i18n.t("rappels_mensuales.detalle.titulo")}`;
  await modal.showModal(RappelMensualDetail, { IdRappelMensual: data.row?.data.Id }, { title: title });
}

async function onExporting(): Promise<void> {
  const inst = grid.value?.instance;
  if (!inst) {
    return;
  }
  await exportGridToExcel(inst, "RappelsFactura.xlsx", "RappelsFactura", true);
}

</script>

<style lang="scss" scoped>


.lupa {
  color: var(--text-secondary-default);
}

.detalle {
  color: var(--text-primary-default);
  cursor: pointer;
}

.exportar-excel {
  color: $base-success;
}
</style>
